export default function TripTravellerAllocationFlightService(
    tripItemFlightRecommendationService
) {
    'ngInject';

    Object.assign(this, {
        getFlightRecommendationAirportCodeRoute,
    });

    function getFlightRecommendationAirportCodeRoute(flightRecommendation) {
        return tripItemFlightRecommendationService
            .getFlightRecommendationAirportCodeRoute(flightRecommendation)
            .join(' - ');
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-recommendation/trip-traveller-allocation-recommendation-service.js